import { makeStyles } from "@material-ui/core/styles";

export const ViewLotStyles = makeStyles(theme => ({
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gridGap: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    marginBottom: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  bidContainer: {
    height: "100%",
  },
  warningMessageContainer: {
    userSelect: "none",
    position: "static",
    opacity: "1",
    backgroundColor: "rgb(236, 110, 19)"
  },
  textLayout: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  iconPosition: {
    marginRight: "5px",
  },
}));
